import { prop } from "ramda";
import { products } from "content";

export const calculateTotal = (obj = products) => {
  return Object.values(obj).reduce((acc, currentValue) => {
    return acc + currentValue.cost * prop("quantity", currentValue);
  }, 0);
};
